import { ethers } from "ethers";
import { getContract } from "utils/blockchain/get-contract";

const baseMainnetProvider = new ethers.providers.JsonRpcProvider(
  "https://base.publicnode.com"
);

const baseGoerliProvider = new ethers.providers.JsonRpcProvider(
  "https://goerli.base.org"
);

let chainId = 84531;
let provider = baseMainnetProvider;
let fantechAddress = getContract(chainId, "fantech");

if (process.env.REACT_APP_APP_ENV === "develop") {
  chainId = 84531;
  provider = baseGoerliProvider;
  fantechAddress = getContract(chainId, "fantech");
}

if (process.env.REACT_APP_APP_ENV === "production") {
  chainId = 8453;
  provider = new ethers.providers.JsonRpcProvider(
    "https://cosmopolitan-dawn-dream.base-mainnet.quiknode.pro/c183d4a04b2f236094334d3ff7b5a6206b36e4a6"
  );
  fantechAddress = getContract(chainId, "fantech");
}

export const appConfig = {
  chainId,
  provider,
  fantechAddress,
};
